import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { publishersAutoCompleteInput$, publishersAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const PublishersAutoSuggest = renderAutoSuggestWithOptions(
   publishersAutoCompleteObservable$,
   publishersAutoCompleteInput$,
);

PublishersAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   publishers: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Publishers...',
};

export default PublishersAutoSuggest;
